import { ReportsService } from './../reports.service';
import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
    selector: 'app-public-medal',
    templateUrl: './public-medal.component.html',
    styleUrls: ['./public-medal.component.scss']
})
export class PublicMedalComponent implements OnInit {
    public medals: any = null;

    constructor(
        private reportsService: ReportsService,
        private spinner: NgxSpinnerService
    ) {
        this.spinner.show();
        document.querySelector('body').classList.add('public-content');

        this.reportsService.getMedal().subscribe(res => {
            this.medals = res;

            setTimeout(() => {
                this.spinner.hide();
            }, 500);
        });
    }

    ngOnInit() {}
}
